"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryItemErrorId = exports.DOStoryItemChange = void 0;
var DOStoryItemChange;
(function (DOStoryItemChange) {
    DOStoryItemChange["ItemCreated"] = "ItemCreated";
})(DOStoryItemChange = exports.DOStoryItemChange || (exports.DOStoryItemChange = {}));
// 존재하지 않는 아이템, 오류가 발생했을 때를 대비하여 넣어둔다.
exports.StoryItemErrorId = -999999;
